import {Component,Input} from '@angular/core';
import {environment} from "@environment";
import {GENERAL_CONDITIONS_ROUTE, PERSONAL_DATA_PROTECTION} from "../../app-routing.module";
import {Router} from "@angular/router";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-consent',
  templateUrl: './consent.component.html',
  styleUrl: './consent.component.scss'
})
export class ConsentComponent {
  environment: any = environment;
  @Input() isProfile: boolean = false;
  @Input() title: string = "";
  constructor(private router: Router, public activeModal: NgbActiveModal) {
  }

  ngOnInit() {
  }


  goToGeneralConditions(): void {
    const url = this.router.serializeUrl(
        this.router.createUrlTree([GENERAL_CONDITIONS_ROUTE]));

    window.open(url, '_blank');
  }

  goToPersonalDataProtection(): void {
    const url = this.router.serializeUrl(
        this.router.createUrlTree([PERSONAL_DATA_PROTECTION]));

    window.open(url, '_blank');
  }

  onConfirmClick() {
    this.activeModal.close()
  }

  onDismissClick(): void {
    this.activeModal.dismiss();
  }


  protected readonly GENERAL_CONDITIONS_ROUTE:string = GENERAL_CONDITIONS_ROUTE;
  protected readonly PERSONAL_DATA_PROTECTION:string = PERSONAL_DATA_PROTECTION;
}